import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-16 bg-legal-dark text-white border-t-4 border-legal-red" data-id="element-135">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-137">
          Need help after a tractor trailer or commercial vehicle accident?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-138">
          Call now or contact the firm to discuss your case.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-139">
          <Button href="tel:18007085433" variant="primary" size="lg" icon="phone" data-id="element-140">
            Call Now: 1-800-708-5433
          </Button>
          <Button href="11014.html" variant="outline" size="lg" icon="mail" className="border-white text-white hover:bg-white hover:text-legal-dark" data-id="element-141">
            Contact Us
          </Button>
        </div>
      </div>
    </section>;
}